import React from 'react';
import './columnHeader.scss';
var ColumnTitle;
(function (ColumnTitle) {
    ColumnTitle["Date"] = "Date";
    ColumnTitle["Title"] = "Title";
})(ColumnTitle || (ColumnTitle = {}));
export var columns = function (handleSorting, sortColumn, sortBy, isLoading, onClickRow) {
    var headerConfig = function (headerProps) {
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return isLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var TitleCell = function (info) { return (React.createElement("span", { onClick: function (event) {
            event.preventDefault();
            onClickRow(info.node.rowIndex);
        }, style: { minWidth: "600px" } }, info.getValue())); };
    return ([
        { field: "Date", headerName: ColumnTitle.Date, sortable: false, headerComponent: headerConfig, flex: 0.8, minWidth: 100 },
        { field: "Title", headerName: ColumnTitle.Title, sortable: false, cellRenderer: TitleCell, headerComponent: headerConfig, flex: 9.2, minWidth: 150 },
    ]);
};
